export const GET_TOP20_ALBUMS = 'GET_TOP20_ALBUMS';
export const GET_TOP20_SONGS = 'GET_TOP20_SONGS';
export const GET_TOP20_ALBUMS_FOR_MAIN_PAGE = 'GET_TOP20_ALBUMS_FOR_MAIN_PAGE';